import { useState, useEffect } from "react";
import ProductStorageHandler from "../../persistence/ProductStorageHandle";
import { isUiModeDeveloper, isUiModeProductAdmin } from "../../uiMode";
import { cleanDecode, cleanEncode } from "../../utils/CommonUtils";
import Logger from "../../Logger";
import { loadImageFromUrl } from "../../modelViews/GraficElementUtils";
import { noItx } from "../../translationItx/itx";

const logger = new Logger();

function getImageLookupIds(imgRef: string): string[] {
  return Array.from(new Set([imgRef, cleanEncode(imgRef), cleanDecode(imgRef)].filter(Boolean)));
}

export default function KnxTypePicture(props: { title: string; imgRef: string; debugElement: any; isCell: boolean }) {
  const { imgRef, title, debugElement, isCell } = props;

  const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);
  const [width, setWidth] = useState<number | undefined>(undefined);

  const scaleForTable: number = 0.4;

  useEffect(() => {
    let disposed = false;
    let objectUrl: string | undefined;

    async function loadImage() {
      try {
        setImgSrc(undefined);
        setWidth(undefined);

        for (const imageId of getImageLookupIds(imgRef)) {
          const imageBlob = await ProductStorageHandler.downloadImageBlob(imageId);
          if (!imageBlob) continue;

          if (disposed) return;

          objectUrl = URL.createObjectURL(imageBlob);
          setImgSrc(objectUrl);

          if (isCell && scaleForTable != 1.0) {
            const img = await loadImageFromUrl(objectUrl);
            if (!disposed && img) {
              setWidth(img.width * scaleForTable);
            }
          }
          return;
        }
      } catch (ex) {
        logger.error(ex);
      }
    }

    loadImage();

    return () => {
      disposed = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [imgRef, isCell]);

  if (imgSrc) {
    if (isCell) {
      return (
        <div>
          <img
            className="knxPicture"
            src={imgSrc}
            style={{ width: width }}
            onContextMenu={(e) => {
              if (isUiModeProductAdmin()) {
                console.log("onContextMenu", e);
                e.stopPropagation();
              }
            }}
          />

          {isUiModeDeveloper() && (
            <div className="knxDebug">
              {imgRef}
              {debugElement}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="knxRow">
          <div className="knxLabel">{title}</div>
          <div className="knxValue">
            <img
              className="knxPicture"
              src={imgSrc}
              // width={"150"}
              onContextMenu={(e) => {
                if (isUiModeProductAdmin()) {
                  console.log("onContextMenu", e);
                  e.stopPropagation();
                }
              }}
            />
          </div>

          {isUiModeDeveloper() && (
            <div className="knxDebug">
              {noItx("imgRef")}
              {debugElement}
            </div>
          )}
        </div>
      );
    }
  } else {
    return null;
  }
}
